import * as React from 'react';

function DashedEastIcon(): React.ReactElement {
  return (
    <svg width="32" height="20" viewBox="0 0 36 24">
      <path d="M22 12H8" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" />
      <path
        d="M20 5l7 7-7 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DashedEastIcon;
